// TypeScript type definitions for rule configuration structure

export interface RuleOption {
  name: string;
  value: string;
}

export interface RuleType {
  description: string;
  group: string;
  variableName: string;
  noun: string;
  allowedOperators: string[];
  objectType: string;
  options: RuleOption[];
  deprecate: string[];
}

export interface RuleTypeGroup {
  ruleTypes: RuleType[];
}

export interface RuleConfiguration {
  [userType: string]: RuleTypeGroup[];
}

// Utility types for working with rule configurations
export type UserType = keyof RuleConfiguration;

// Alternative functional approach using flatMap and reduce
export function getUniqueRuleTypes(config: RuleConfiguration): RuleType[] {
  // Flatten all rule types from all user types and groups
  const allRuleTypes = Object.values(config)
    .flatMap(userGroups => userGroups)
    .flatMap(group => group.ruleTypes);
  
  // Deduplicate by variableName using Map to preserve order and keep first occurrence
  const uniqueRuleTypesMap = allRuleTypes.reduce((map, ruleType) => {
    if (!map.has(ruleType.variableName)) {
      map.set(ruleType.variableName, ruleType);
    }
    return map;
  }, new Map<string, RuleType>());
  
  return Array.from(uniqueRuleTypesMap.values());
}